import { getEnvs } from "../utils/get-envs";
const {
  VITE_API_URL, VITE_DRIVEAPI_URL, VITE_BUCKET_BASE, VITE_RADIUS_URL, VITE_API_SOFTNET_URL
} = getEnvs();

export const urlBackend: string = VITE_API_URL;
export const urlBackendVersion: string = VITE_API_URL;
export const urlDrive: string = `${VITE_DRIVEAPI_URL}${VITE_BUCKET_BASE}/v1/archivos/`;
export const urlBucket: string = `${VITE_DRIVEAPI_URL}${VITE_BUCKET_BASE}/image/instalacion/`;
export const urlDriveSingle: string = `${VITE_DRIVEAPI_URL}${VITE_BUCKET_BASE}/v1/`;
export const urlRadius: string = `${VITE_RADIUS_URL}`;
export const urlBackendSoftnet: string = `${VITE_API_SOFTNET_URL}`;

//NAP
export const urlNapByCiudad = (
  ciudad: string,
  page_size: number,
  sector?: number,
  lat?: string,
  lng?: string,
) =>
  urlBackend +
  "api/naps/?page_size=" +
  page_size +
  "&ciudad=" +
  ciudad +
  `${sector ? "&sector=" + sector : ""}` +
  `${lat ? "&lat=" + lat : ""}` +
  `${lng ? "&lng=" + lng : ""}`;

export const urlApiPaymentMethod: string = urlBackend + "api/v1/formapago/";
export const urlIApiPaymentMethodProveedor: string =
  urlBackend + "api/v1/formapagoproveedor/";
export const urlApiRecurrencia: string = urlBackend + "api/v1/recurrencias/";
export const urlApiTipoDocumento: string =
  urlBackend + "api/v1/tipos-documentos/";
export const urlApiPoligono: string = urlBackend + "api/v1/punto-en-poligono/";
